import makeStyles from "@material-ui/styles/makeStyles";

const styles = makeStyles(theme => ({
	root: {
		fontFamily: "Source Sans Pro",
		"& video": {
			aspectRatio: "1920 / 1080",
			height: "100%",
			objectFit: "cover",
			display: "block",
			width: "100%"
		}
	},
	videoWrapper: {
		alignItems: "center",
		aspectRatio: "1920 / 1080",
		display: "flex",
		justifyContent: "center",
		position: "relative"
	},
	nav: {
		alignItems: "center",
		background: "rgba(0,0,0,0.5)",
		cursor: "pointer",
		display: "flex",
		height: 40,
		justifyContent: "center",
		position: "absolute",
		top: "50%",
		marginTop: -20,
		width: 40,
		[theme.breakpoints.up("md")]: {
			height: 56,
			marginTop: -28,
			width: 56
		},
		"&.video-player-root__nav--next": {
			right: 0
		},
		"&.video-player-root__nav--prev": {
			left: 0
		},
		"& svg": {
			width: "32px !important",
			[theme.breakpoints.up("md")]: {
				width: "40px !important"
			}
		}
	},
	options: {
		alignItems: "center",
		background: "#FFFFFF",
		display: "flex",
		flexDirection: "column",
		margin: "0 auto",
		rowGap: theme.spacing(2.5),
		padding: theme.spacing(2),
		[theme.breakpoints.up(374)]: {
			alignItems: "flex-start"
		},
		[theme.breakpoints.up("sm")]: {
			alignItems: "center",
			flexDirection: "row",
			flexWrap: "wrap",
			gap: theme.spacing(5),
			justifyContent: "center",
			maxWidth: "none",
			padding: theme.spacing(2.5, 4)
		},
		[theme.breakpoints.up("lg")]: {
			display: "grid",
			gridTemplateColumns: "auto auto auto 1fr",
			gap: theme.spacing(7)
		},
		"& .video-player-root__buttons": {
			alignItems: "center",
			display: "flex",
			flexWrap: "wrap",
			gap: theme.spacing(1),
			justifyContent: "center",
			[theme.breakpoints.up("sm")]: {
				display: "grid",
				gridTemplateColumns: "1fr 1fr 1fr 1fr",
				gridTemplateRows: "1fr auto",
				gridRowGap: theme.spacing(1),
				textAlign: "center"
			}
		},
		"& .video-player-root__buttons-button": {
			alignItems: "center",
			border: "1px solid #A29786",
			borderRadius: "50%",
			cursor: "pointer",
			display: "flex",
			height: 48,
			justifyContent: "center",
			transition: "background 250ms ease, border 250ms ease, color 250ms ease",
			width: 48,
			[theme.breakpoints.up(374)]: {
				height: 55,
				width: 55
			},
			"& svg path": {
				fill: "#A29786"
			},
			"&:hover": {
				background: theme.palette.primary.main,
				border: "1px solid " + theme.palette.primary.main,
				color: "#FFFFFF",
				"& svg path": {
					fill: "#FFFFFF !important"
				}
			},
			"&.video-player-root__buttons-button--selected": {
				background: theme.palette.primary.main,
				border: "1px solid " + theme.palette.primary.main,
				color: "#FFFFFF",
				"& svg path": {
					fill: "#FFFFFF !important"
				}
			},
			"&.video-player-root__buttons-button--disabled": {
				background: "none !important",
				border: "1px solid #A29786 !important",
				opacity: 0.3,
				pointerEvents: "none",
				"& svg path": {
					fill: "#A29786 !important"
				}
			}
		},
		"& .video-player-root__buttons-label": {
			color: "#A29786",
			fontWeight: 700,
			fontSize: 12,
			letterSpacing: "0.4px",
			flex: "1 0 100%",
			paddingLeft: theme.spacing(0),
			textAlign: "center",
			textTransform: "uppercase",
			[theme.breakpoints.up(374)]: {
				flex: "unset",
				paddingLeft: theme.spacing(1),
				textAlign: "left"
			},
			[theme.breakpoints.up("sm")]: {
				gridColumn: "1 / -1",
				paddingLeft: theme.spacing(0),
				textAlign: "center"
			}
		}
	},
	optionsHighlights: {
		"& .video-player-root__buttons--weather": {
			"& .video-player-root__buttons-label": {
				opacity: 0.3 + " !important"
			},
			"& .video-player-root__buttons-button": {
				background: "none !important",
				border: "1px solid #A29786 !important",
				opacity: 0.3 + " !important",
				pointerEvents: "none",
				"& svg path": {
					fill: "#A29786 !important"
				}
			}
		},
		"& .video-player-root__buttons--time": {
			"& .video-player-root__buttons-label": {
				opacity: 0.3 + " !important"
			},
			"& .video-player-root__buttons-button": {
				background: "none !important",
				border: "1px solid #A29786 !important",
				opacity: 0.3 + " !important",
				pointerEvents: "none",
				"& svg path": {
					fill: "#A29786 !important"
				}
			}
		}
	},
	controls: {
		alignItems: "center",
		display: "flex",
		flexWrap: "wrap",
		gap: theme.spacing(3),
		justifyContent: "space-between",
		maxWidth: 500,
		width: "100%",
		[theme.breakpoints.up("sm")]: {
			justifyContent: "center",
			width: "auto"
		},
		[theme.breakpoints.up("md")]: {
			flexDirection: "row",
			gridRowGap: theme.spacing(3),
			textAlign: "center"
		},
		[theme.breakpoints.up("lg")]: {
			marginLeft: "auto"
		}
	},
	controlsItem: {
		alignItems: "center",
		display: "flex",
		flexDirection: "column",
		flexWrap: "wrap",
		gap: theme.spacing(1),
		justifyContent: "center",
		[theme.breakpoints.up("md")]: {
			gridRowGap: theme.spacing(1),
			textAlign: "center"
		},
		"& .video-player-root__buttons-label": {
			padding: 0
		}
	},
	controlsButtonActive: {
		background: theme.palette.primary.main,
		border: "1px solid " + theme.palette.primary.main + " !important",
		color: "#FFFFFF",
		"& svg path": {
			fill: "#FFFFFF !important"
		}
	}
}));

export default styles;
